import React from 'react';
import { SubmittedRequestClientProfileList } from "./submitted-request/SubmittedRequestClientProfileList";
import {
    submittedRequestListReducer,
    initState,
    SubmittedRequestListFilterValue
} from "./submitted-request/submittedRequestListReducer";

export const ClientProfileSubmittedRequestListPage = ({ clientGuid }: SubmittedRequestListFilterValue) => {
    const [{
        pagination,
        sortBy,
        filter,
        selected,
        search,
        pageSize
    }, dispatch] = React.useReducer(submittedRequestListReducer, {
        ...initState(),
        filter: {
            ...initState().filter,
            clientGuid: clientGuid,
            status: "",  // Client page: show all statuses by default
        }
    });

    return (
        <SubmittedRequestClientProfileList
            dispatch={dispatch}
            pagination={pagination}
            filterValue={filter}
            selectedRequest={selected}
            searchText={search}
            sortBy={sortBy}
            pageSize={pageSize}
        />
    );
};
